import React from 'react'
import Traduction from 'Components/Traduction'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Utils from 'EurestoFonction/Utils'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'

import 'emoji-mart/css/emoji-mart.css'
import {Emoji, Picker} from 'emoji-mart'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getFlag()
    }
  }

  getFlag = async () => {
    const result = await ApiRequest(project.api + 'sdd', {
      requete: 'flag',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle && result.results.libelle.length > 0 && result.results.libelle[0].text,
        libelle: result.results.libelle,
        icon: result.results.icon,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      icon: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'sdd', {
      requete: 'flag',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      icon: this.state.icon,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'sdd', {
      requete: 'flag',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="flex-start"
            alignItems="stretch">
        <Grid container justify={'center'} alignItems={'center'}>
          <Picker onSelect={emoji => this.onChangeState(emoji.colons, 'icon')} set='emojione'/>
        </Grid>
        <Grid container>
          <Grid item>
            <Grid container justify={'center'} alignItems={'center'} style={{ height: '100%' }}>
              <Emoji emoji={this.state.icon || ':santa::skin-tone-3:'} size={32}/>
            </Grid>
          </Grid>
          <Grid item xs>
            <Traduction
              key={autoFocus}
              autoFocus={autoFocus}
              title={EurestoI18n.t('commun:Nom')}
              disabled={disabled}
              onChange={this.onChangeState}
              name={'libelle'}
              data={this.state.libelle !== undefined ? this.state.libelle : []}
              type={Constants.typeSaisie.SaisieLibre}
            />
          </Grid>
        </Grid>
      </Grid>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.defaultLibelle}
                   action={this.state.action}
                   isAllow={this.props.isAllow}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={EurestoI18n.t('commun:Nouvelle civilité')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Messagerie/Flag.js